import { getGroupPlan, getIndividualPlan } from './plans';

(function ($) {
  let state = {};

  let $giftCheckbox = $("#purchase-as-gift");

  const $numberVisitsContent = $('.number-of-visits');
  const $numberPeopleContent = $('.how-many-people');
  const $btnScrollQ1 = $('.btn-scroll-q1');

  const URL_BASE = "https://www.showcasesubscribe.com/";

  function updateView(preventScroll) {
    // update pricing
    console.log(state);

    $numberPeopleContent.show();
    $numberVisitsContent.hide();

    let plan = null;

    if (state.people) {
      $numberVisitsContent.show();
    }

    if (state.people && state.numberOfVisits) {
      plan = getGroupPlan(state.people, state.numberOfVisits);
    }

    if (plan) {
      const url2d = state.isGift ? plan['2d'].url.gift : plan['2d'].url.nonGift;
      const urlPremier = state.isGift ? plan.premier.url.gift : plan.premier.url.nonGift;

      $(".pricing").show();

      $("#2d span").text(plan['2d'].price);
      $("#premier span").text(plan.premier.price);

      $("#2d a").attr("href", URL_BASE + url2d);
      $("#premier a").attr("href", URL_BASE + urlPremier);
    } else {
      $(".pricing").hide();
    }

    if (!preventScroll) {
      $('html, body').animate({
        scrollTop: $(document).height() - $(window).height() - $("#footer").height() - 120
      }, 500);
    }
  }

  // initial render
  state.isGift = $giftCheckbox.is(':checked');
  updateView(true);

  //handlers
  $btnScrollQ1.on('click', e => {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $("#question-1").offset().top
    }, 500);
  });

  $numberPeopleContent.on('click', 'a', e => {
    state.people = $(e.target).data("people");
    $numberPeopleContent.find("a").removeClass("selected");
    $(e.target).addClass("selected");
    updateView();
  });

  $numberVisitsContent.on('click', 'a', e => {
    state.numberOfVisits = $(e.target).data("visits");
    $numberVisitsContent.find("a").removeClass("selected");
    $(e.target).addClass("selected");
    updateView();
  });

  $giftCheckbox.on('change', e => {
    state.isGift = e.target.checked;
    updateView(true);
  });


})(jQuery);